<template>
  <DefaultLayout>
    <template #sidebar="{ collapsed }">
      <DefineButtonTemplate>
        <UButton
          icon="i-ph-arrow-up-right"
          :label="collapsed ? null : 'Voir la plateforme'"
          trailing
          color="neutral" variant="subtle"
          :to="`https://${platform?.domain}`"
          class="justify-between"
          target="_blank"
          :square="collapsed"
        />
      </DefineButtonTemplate>
      <UTooltip v-if="collapsed" text="Voir la plateforme" :content="{ side: 'right' }">
        <ReuseButtonTemplate />
      </UTooltip>
      <ReuseButtonTemplate v-else />
      <UNavigationMenu
        :collapsed="collapsed"
        :items="links"
        orientation="vertical"
        tooltip
        popover
      />
    </template>

    <template #default>
      <slot/>
    </template>

  </DefaultLayout>
</template>

<script setup>
import DefaultLayout from './default.vue'

const platform = useState('platform')
const isAdmin = useState('isAdmin')

const [DefineButtonTemplate, ReuseButtonTemplate] = createReusableTemplate()

const links = computed(() => {
  if (!platform.value) {
    return [];
  }
  let links = [
    {
      id: 'stats',
      label: 'Statistiques',
      to: `/platform/${platform.value.id}/stats`,
      icon: 'i-ph-chart-pie-slice-duotone',
    },
  ];

  if (platform.value.settings.page_builder || isAdmin.value) {
    links.push({
      label: 'Pages de contenu',
      to: `/platform/${platform.value.id}/page`,
      icon: 'i-ph-files-duotone',
      class: !platform.value.settings.page_builder ? 'text-admin' : ''
    })
  }

  const settings = []

  if (isAdmin.value) {
    settings.push({
      label: 'Général',
      to: `/platform/${platform.value.id}/settings`,
      exact: true,
      class: 'text-admin',
    })
  }

  settings.push(...[{
      label: 'Gestion des accès',
      to: `/platform/${platform.value.id}/settings/permission`,
    },
    {
      label: 'Créer un widget',
      to: `/widget-configurator?url=https://${platform.value.domain}`,
      external: true,
      target: '_blank',
    }
  ])

  links.push(...[
    {
      label: 'Personnalisation',
      icon: 'i-ph-pencil-duotone',
      defaultOpen: true,
      children: [
        {
          label: 'Général',
          to: `/platform/${platform.value.id}/customization`,
          exact: true,
        },
        {
          label: 'Page d\'accueil',
          to: `/platform/${platform.value.id}/customization/home`,
        },
      ],
    },
    {
      id: 'settings',
      label: 'Paramètres',
      icon: 'i-ph-gear-duotone',
      defaultOpen: true,
      children: settings,
    }
  ])

  if (platform.value.simplfied_group && (useState('profile').value.groups.find((p) => p.id === platform.value.simplfied_group.id) || useState('profile').value.account_type === 'admin' || useState('isAdmin').value)) {
    links = [links, [{
      label: 'Gérer le réseau',
      to: `/group/${platform.value.simplfied_group.id}`,
      icon: 'i-ph-arrow-square-in',
    }]]
  }

  return links;
});

</script>
